import { SettingsOptionsTransitionAfterIntroduction } from '../domain/transitionAfterIntroduction/types';

// 検索条件項目のデフォルトデータ
export const settingsOptionsTransitionAfterIntroductionDefaultValue: SettingsOptionsTransitionAfterIntroduction =
  {
    searchCondition: {
      makers: [],
      kiList: [],
      shuGroupList: [],
      shuList: [],
      areas: [],
      halls: [],
      sisTypes: [],
      latestBaseDateForDailySisData: '',
      latestBaseDateForWeeklySisData: '',
      latestBaseDateForMonthlySisData: '',
    },
    fields: {
      transition: [],
      nonTransition: [],
    },
    genres: {
      transition: [],
    },
  };
